export enum SelectBlock {
  Root = 'Select',
}

export enum SelectModifier {
  Search = 'search',
  Highlighted = 'highlighted',
  NoClear = 'noClear',
}
